import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Button, Stack, Typography } from '@dtx-company/design-system/src'
import {
  DemoModalDefaultButtonLabel,
  DemoModalDefaultRedirectRoute,
  DemoModalGraphics
} from '../../constants/demoModal'
import { DemoModalWrapper } from './style'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { LockModalProGraphicBG } from '@app/code/src/assets'
import { Modal, ModalVariants } from '@dtx-company/shared-components/src'
import { PrimaryButton } from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { fireHeapEvent } from '@dtx-company/inter-app/src/event-tracking/helpers'
import { useDemoModal } from '../../hooks/useDemoModal/useDemoModal'
import { useRouter } from 'next/router'
import React from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/proConversion'

export const DemoModal: React.FC = () => {
  const router = useRouter()
  const { onClose, modalOpen, demoModalVariant } = useDemoModal()
  const { header, graphic, footer, margin, buttonLabel, route, version, cancelButton } =
    (demoModalVariant && DemoModalGraphics[demoModalVariant as keyof typeof DemoModalGraphics]) ||
    {}
  const redirectRoute = route || DemoModalDefaultRedirectRoute
  const v2 = version === 'v2'
  return (
    <Modal
      variant={[ModalVariants.SHEET, ModalVariants.DESKTOP]}
      onClose={onClose}
      open={modalOpen}
      top={'unset'}
      disableAutoClose
    >
      <DemoModalWrapper background={v2 ? undefined : `url(${LockModalProGraphicBG})`}>
        <Box flexDirection={'column'} m={'48px 32px 16px 32px'}>
          {v2 ? (
            <Typography variant={'headlineSmall'}>{header}</Typography>
          ) : (
            <Text variant={'display/medium'} textAlign={'center'}>
              {header}
            </Text>
          )}
        </Box>
        <Box maxHeight={'300px'} margin={margin}>
          <Image m={'auto'} src={graphic || ''} height={'100%'} />
        </Box>
        <Box flexDirection={'column'} justifyContent={'space-between'} m={'16px 32px 32px 32px'}>
          {footer && (
            <>
              <Text variant={'body/medium'} textAlign={'center'}>
                {footer}
              </Text>
              <Spacer mb={'16px'} />
            </>
          )}
          <Stack direction={'row'} gap={3} sx={{ justifyContent: 'flex-end' }}>
            {cancelButton && (
              <Button
                variant={'text'}
                onClick={() => {
                  fireHeapEvent('Demo_Modal_Clicked_Cancel_Button', {
                    variant: demoModalVariant,
                    route: redirectRoute
                  })
                  onClose()
                }}
              >
                Cancel
              </Button>
            )}
            {demoModalVariant && v2 && (
              <Button
                variant={'contained'}
                onClick={() => {
                  events.Pro_Flex_Demo_Modal_Clicked_Button({
                    variant: demoModalVariant,
                    route: redirectRoute
                  })
                  if (v2) {
                    window.open(redirectRoute, '_blank')
                  } else {
                    router.push(redirectRoute)
                  }
                  onClose()
                }}
              >
                {buttonLabel || DemoModalDefaultButtonLabel}
              </Button>
            )}
            {demoModalVariant && !v2 && (
              <PrimaryButton
                label={buttonLabel || DemoModalDefaultButtonLabel}
                maxWidth={'500px'}
                width={'100%'}
                style={{ margin: 'auto' }}
                onClick={() => {
                  events.Pro_Flex_Demo_Modal_Clicked_Button({
                    variant: demoModalVariant,
                    route: redirectRoute
                  })
                  router.push(redirectRoute)
                  onClose()
                }}
              />
            )}
          </Stack>
        </Box>
      </DemoModalWrapper>
    </Modal>
  )
}
